import { render, staticRenderFns } from "./ArchivoListar.vue?vue&type=template&id=1f92fb2e&"
import script from "./ArchivoListar.vue?vue&type=script&lang=js&"
export * from "./ArchivoListar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports